import React from 'react';

import { BasketDiscountType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';
import { useCampaignModuleContext } from 'modules/campaigns/context';

export type DiscountAmountLabelProps = {
  discountAmount: number;
  discountType: BasketDiscountType;
};

export const DiscountAmountLabel = ({ discountAmount, discountType }: DiscountAmountLabelProps) => {
  const { currency } = useCampaignModuleContext();

  if (discountType === BasketDiscountType.AMOUNT) {
    return <MonetaryAmount amount={convertMonetaryIntToDecimal(discountAmount, currency)} currency={currency} />;
  }

  return <>{discountAmount}%</>;
};
